import { webDtos } from '@vectronic/openApi-customer';

export const COLLARS: (webDtos.CollarExtended & { collarKey: string })[] = [
  {
    id: 1,
    name: 'collar_1',
    label: 'label',
    comId: '456',
    comType: 'IRIDIUM',
    collarKey:
      '1C94EFB65BB1547C49EFE53D694BE8EC0712F8FA9072883BDF599698AF15B78E5F8981F9F61097FA28C6C03CCE62EDC2C972A3886A686A382822C200E5468F77370CF5046DBBAFDB8BF33D9BCE0AFD6A827D5EAEF3D5B6DB91934DC5816CAFF980A2FE90C2DA48426A3DA735E1E95583C97D952AE61EB83E9A0E9F67408DAD520F199CA68E6D2D9E1E7A7C1116F54399A8EFE64D691A039170F3625E849821DED76095C5E6C1C0668F1FE477B414D88F94D41497AF0795F1A1FD6436EB9CAE4DCA67D5D66A1BAF584D4BF4DC81D4140705FAA5C3E360ED3C15EDE910F0FDAA246A5F6D2D0E97FEA8442EB519EA196E769C289B85EDF7DD3AAD81F2146C355379',
    blacklisted: false,
    lastReception: new Date(2017, 4, 4, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 2,
    name: 'collar_2',
    label: 'label',
    comId: '789',
    comType: undefined,
    collarKey:
      '053466C2FB87433DB6F12001DB33ED594B22001E2636DAC275E5B4F067EFDCA5F7040C08AAF176AF6D688764ECC86CCA59AA577FE500E0CB40C4FDCAE3E3EF84FC9A9DDE180468B63EBA26D253995B6B665C5318F4A4AAA522B67B2FFFDDC14E64A5F79B8948A3535F1285AF01727123C8BC9ACECFC51D5166865AB18ABF8B393DE083CE83DE4E9857E9F096FFF7D71572B57C12D94DBE80F085689ECD9DA7CBC4A3517728A6AE4BAD851A3DFC7DE464D484DE0E15E38947CA76E95F58785D145CD5FBA291909F057CDA8700E845409F985E1D8EE2EB99D99FB88954C6826CA1ED54FB116AD3195B2EF43418494639406CD8EE7C3B9C8D884680DBDB7BE07DF6',
    blacklisted: false,
    lastReception: new Date(2019, 7, 11, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 3,
    name: 'collar_3',
    label: 'label',
    comId: '123',
    comType: undefined,
    collarKey: 'fsfsf55asfsdfd',
    blacklisted: false,
    lastReception: new Date('2018-05-11').toISOString(),
    role: 'OWNER',
  },
  {
    id: 4,
    name: 'collar_4',
    label: 'label',
    comId: '456',
    comType: undefined,
    collarKey: 'a456afafdfw8',
    blacklisted: false,
    lastReception: new Date(2017, 4, 4, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 5,
    name: 'collar_5',
    label: 'label',
    comId: '789',
    comType: undefined,
    collarKey: 'a45dffff555',
    blacklisted: false,
    lastReception: new Date(2019, 7, 11, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 6,
    name: 'collar_6',
    label: 'label',
    comId: '123',
    comType: undefined,
    collarKey: 'fsfsf888sdfd',
    blacklisted: false,
    lastReception: new Date('2018-05-11').toISOString(),
    role: 'OWNER',
  },
  {
    id: 7,
    name: 'collar_7',
    label: 'label',
    comId: '456',
    comType: undefined,
    collarKey: 'a4wwwwasfw8',
    blacklisted: false,
    lastReception: new Date(2017, 4, 4, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 8,
    name: 'collar_8',
    label: 'label',
    comId: '789',
    comType: undefined,
    collarKey: 'a45hhfasfsdfd',
    blacklisted: false,
    lastReception: new Date(2019, 7, 11, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 9,
    name: 'collar_9',
    label: 'label',
    comId: '123',
    comType: undefined,
    collarKey: 'fsf545444asfsdfd',
    blacklisted: false,
    lastReception: new Date('2018-05-11').toISOString(),
    role: 'OWNER',
  },
  {
    id: 10,
    name: 'collar_10',
    label: 'label',
    comId: '456',
    comType: undefined,
    collarKey: 'a456afsssw8',
    blacklisted: false,
    lastReception: new Date(2017, 4, 4, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 11,
    name: 'collar_11',
    label: 'label',
    comId: '789',
    comType: undefined,
    collarKey: 'a45derf4g555',
    blacklisted: false,
    lastReception: new Date(2019, 7, 11, 17, 23, 42, 11).toISOString(),
    role: 'OWNER',
  },
  {
    id: 12,
    name: 'collar_12',
    label: 'label',
    comId: '123',
    comType: undefined,
    collarKey: 'fsfsfjj8sdfd',
    blacklisted: false,
    lastReception: new Date('2018-05-11').toISOString(),
    role: 'OWNER',
  },
  {
    id: 13,
    name: 'collar_13',
    label: 'label',
    comId: '123',
    comType: undefined,
    collarKey: 'fsfsfjj8sdfd',
    blacklisted: false,
    lastReception: new Date('2018-05-11').toISOString(),
    role: 'OWNER',
  },
  {
    id: 14,
    name: 'collar_14',
    label: 'label',
    comId: '123',
    comType: undefined,
    collarKey: 'fsfsfjj8sdfd',
    blacklisted: false,
    lastReception: new Date('2018-05-11').toISOString(),
    role: 'OWNER',
  },
  {
    id: 15,
    name: 'collar_15',
    label: 'label',
    comId: '123',
    comType: undefined,
    collarKey: 'fsfsfjj8sdfd',
    blacklisted: false,
    lastReception: new Date('2018-05-11').toISOString(),
    role: 'OWNER',
  },
  {
    id: 16,
    name: 'collar_16',
    label: 'label',
    comId: '123',
    comType: undefined,
    collarKey: 'fsfsfjj8sdfd',
    blacklisted: false,
    lastReception: new Date('2018-05-11').toISOString(),
    role: 'OWNER',
  },
  {
    id: 17,
    name: 'collar_17',
    label: 'label',
    comId: '123',
    comType: undefined,
    collarKey: 'fsfsfjj8sdfd',
    blacklisted: false,
    lastReception: new Date('2018-05-11').toISOString(),
    role: 'OWNER',
  },
];
